import { call, all } from "redux-saga/effects";

import { LoginActionWatcher } from "../containers/LoginContainer/saga";
import { dashboardActionWatcher } from "../containers/DefaultLayout/saga";
import { CustomerDetailsWatcher } from "../containers/CustomerViewContainer/saga";
import { MyCasesActionWatcher } from "../containers/MyCasesContainer/saga";
import { UserActionWatcher } from "../containers/UserContainer/saga";
import { CustomerBulkAssign } from "../containers/CustomerBulkAssign/saga";
import {CustomerImportActionWatcher} from '../containers/ImportCustomerContainer/saga'
import {BulkUserAddWatcher} from '../containers/BulkUserAddContainer/saga'
import {ForgotResetPwdActionWatcher} from '../containers/ForgotPasswordContainer/saga'
import {resetPasswordVoucher} from '../containers/ResetPasswordContainer/saga'
import {BulkPinUpdateWatcher} from '../containers/BulkPinUpdate/saga'

function* rootSaga() {
  yield all([
    call(LoginActionWatcher),
    call(dashboardActionWatcher),
    call(CustomerDetailsWatcher),
    call(UserActionWatcher),
    call(MyCasesActionWatcher),
    call(CustomerBulkAssign),
    call(CustomerImportActionWatcher),
    call(BulkUserAddWatcher),
    call(ForgotResetPwdActionWatcher),
    call(resetPasswordVoucher),
    call(BulkPinUpdateWatcher)
  ]);
}

export default rootSaga;
